import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FieldArray, withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../common/js/form-helpers";
import {activateUser, assignmentEmployeeAction} from "../../actions/actions";
import {handleApiResponse} from "../../../../common/js/crud-actions";
import {setNotification} from "../../../../common/js/notifications/notifications-actions";
import {Link, withRouter} from "react-router-dom";
import Notifications from "../../../../common/js/notifications/components/notifications";
import Footer from "../layout/footer";
import {Button, CustomInput, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import CAppComponent from "../capp-component";
import qs from "query-string";
import ci from '../../../../common/js/common-images';
import PrivacyPolicy from "../../../../common/js/components/privacy-policy";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class InnerForm extends CAppComponent {
    constructor(props) {
        super(props);
        this.state = {
            modalGdpr: false
        };
    }

    toggleGdpr = () => {
        this.setState({ ...this.state, modalGdpr: !this.state.modalGdpr});
    };

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                { displayErrors(errors, 'base') }
                { displayErrors(errors, 'email', { name: 'Tento účet'}) }
                { displayErrors(errors, 'confirmation_token', { name: 'Potvrzovací token'}) }
                <input type='hidden' value={values.confirmation_token} id='confirmation_token' name='confirmation_token'/>
                <div className='form-group'>
                    <FormattedMessage id='app.confirmation.password'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <input type='password' placeholder='' className='form-control' id='password' value={values.password} onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'password') }
                    <div className='shift'>
                        <FormattedMessage id='app.confirmation.password_instructions'>{(txt) => (<small className='text-white'>{txt}</small>)}</FormattedMessage>
                    </div>
                </div>
                <div className='form-group'>
                    <FormattedMessage id='app.confirmation.password_confirmation'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <input type='password' placeholder='' className='form-control' id='password_confirmation' value={values.password_confirmation} onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'password_confirmation') }
                </div>
                <div className='form-group shift mb-5'>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id="confirmation_gdpr" onChange={handleChange}/>
                        <FormattedMessage id='app.confirmation.gdpr_i_agree'>{(txt) => (<a href='https://www.gasnet.cz/-/media/GasNet/Files/Gasnet/gdpr/IM_pro_subjekty_udaju_HR_Onboarding.pdf' className='txt-16' target="_BLANK">{txt}&nbsp;&nbsp;<FontAwesomeIcon icon={['far', 'external-link']}/></a>)}</FormattedMessage>
                    </div>
                    { displayErrors(errors, 'confirmation_gdpr') }
                </div>
                <div className='form-group shift'>
                    <button type='submit' className='btn btn-block btn-green' disabled={isSubmitting}>{intl.formatMessage({id: 'app.actions.save'})}{ this.spinner(isSubmitting) }</button>
                </div>
            </form>
        )
    }
}

InnerForm = injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => props.initialValues,
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'ConfirmationForm',
})(InnerForm));


class Confirmation extends CAppComponent {

    constructor(props) {
        super(props);

        this.state = {
            screen: null
        };
    }

    activateUser= (values, form) => {
        let promise = this.props.activateUser(values);
        handleApiResponse('ACCOUNT', 'ACTIVATION', promise,
            (result) => {
                this.setState({...this.state, screen: 'success'});
            },
            (result) => {
                // this.setState({...this.state, screen: 'already_activated'});
                form.setErrors(result.payload.response.errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }
        ).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        let params = qs.parse(this.props.location.search);
        let token = params['ct'];

        if (this.state.screen === 'success' ) {
            return (
                <div>
                    <section className='main-content-menuless bg-gray'>
                        <div className='container'>
                            <Notifications/>
                            <div className='row pa'>
                                <div className='col-md-6'>
                                    <img src={ci.gasnet_logo_white} className='mb-4'/>
                                    <FormattedMessage id='app.confirmation.activated'>{(txt) => (<h1 className='mb-5'>{txt}</h1>)}</FormattedMessage>
                                    <p><FormattedMessage id='app.confirmation.you_may_sign_in'/></p>
                                    <Link to='/sign-in' className='btn btn-green'><FormattedMessage id='app.confirmation.sign_in'/></Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer/>
                </div>
            );
        }

        return (
            <div>
                <section className='main-content-menuless bg-gray'>
                    <div className="bg-white text-left">
                        <div className="container pt-4 pb-4">
                            <img src={ci.gasnet_logo_green} width='140' height='50'/>
                        </div>
                    </div>
                    <div className='container pt-7 pb-7'>
                        <Notifications/>
                        <div className='row pa justify-content-between'>
                            <div className='col-lg-5 mb-4'>
                                <img src={ci.gasnet_logo_white} width='111' height='90' className='mb-4'/>
                                <hr className='gasnet-divider'/>
                                <FormattedMessage id='app.confirmation.welcome'>{(txt) => (<h1 className='mb-5'>{txt}</h1>)}</FormattedMessage>
                                <FormattedMessage id='app.confirmation.lets_activate'>{(txt) => (<h2 className='text-gasnet-green'>{txt}</h2>)}</FormattedMessage>
                                <FormattedMessage id='app.confirmation.activation_instructions'>{(txt) => (<p>{txt}</p>)}</FormattedMessage>
                                <p>
                                    <FormattedMessage id='app.confirmation.sign_in_instructions'>{(txt) => (<span>{txt}</span>)}</FormattedMessage> <FormattedMessage id='app.confirmation.sign_in_button'>{(txt) => (<Link to={'/sign-in'} className='text-gasnet-green-dark'><u>{txt}</u></Link>)}</FormattedMessage>
                                </p>
                            </div>
                            <div className='col-lg-6'>
                                <div className='card bg-gray'>
                                    <div className='card-body confirmation-form'>
                                        <InnerForm initialValues={{
                                            confirmation_token: token,
                                            password: '',
                                            password_confirmation: '',
                                            confirmation_gdpr: false
                                        }} submit={this.activateUser}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer/>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        activateUser: activateUser,
        setNotification: setNotification
    }, dispatch);
}

export default withRouter(injectIntl(connect(mapStateToProps, matchDispatchToProps)(Confirmation)));
